import React, {useEffect, useRef, useState} from 'react'
import FadeIn from '../components/FadeIn'
import { Link } from 'react-router-dom'
import MenuBig from "../components/MenuBig";
import FadeInMenu from "../components/FadeInMenu";
import ImageSlide from "../components/ImageSlide";
import FungsiSection from "../components/FungsiSection";
import Articles from "../components/Articles";
import getSettingsList from "../api/settings";

const HomeContent = () => {
    const [tiktok, setTiktok] = useState('https://www.tiktok.com/@inspektoratkabpaniai')
    const isMounted = useRef(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://www.tiktok.com/embed.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            const existingScript = document.querySelector('script[src="https://www.tiktok.com/embed.js"]');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        }
    })

    useEffect(() => {
        if (isMounted.current) {
            return;
        }

        isMounted.current = true;

        getSettingsList().then(res => {
            res.forEach(item => {
                if(item.key === "linktiktok"){
                    setTiktok(item.value)
                }
            })
        })

        return () => {

        }
    });

    return (
        <div className='w-auto'>
            <section className='h-760 mb-10'>
                <div className='relative'>
                    <div className='bg-black-500 absolute h-760 w-full'>
                        <ImageSlide />
                    </div>
                    <div className='absolute inset-0 items-center justify-center'>
                        <div className='flex flex-col items-center justify-center mt-24'>
                            <div>
                                <FadeIn delay={0.2} direction="down" padding fullWidth>
                                    <h1 className='text-left text-5xl desktop:text-5xl phone:text-3xl leading-tight xs:text-[64px] text-white max-w-[1050px]'>
                                        Selamat Datang di website resmi <br/><strong>Inspektorat Kab. Paniai</strong>
                                    </h1>
                                </FadeIn>
                                <FadeIn delay={0.5} direction="left" padding fullWidth>
                                    <h1 className='mt-[50px] text-left text-lg leading-tight xs:text-[64px] text-white max-w-[1050px] bg-gray-800 p-5 rounded-md bg-opacity-50'>
                                        Adalah lembaga yang bertugas mengawasi dan memeriksa kegiatan Pemerintah Daerah untuk memastikan transparansi, efisiensi, dan kepatuhan terhadap peraturan, serta memberikan rekomendasi untuk perbaikan kinerja.
                                    </h1>
                                </FadeIn>
                                <FadeIn delay={0.4} direction='right' padding fullWidth>
                                    <Link to='/pengaduan' className='btn mt-[50px] bg-orange-600 p-5 rounded-md hover:bg-orange-400 text-white'>
                                        Buat Pengaduan
                                    </Link>
                                </FadeIn>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='h-600 mb-10'>
                <FungsiSection />
            </section>

            <section id='pelayanan' className='bg-blue-950 h-600'>
                <FadeIn delay={0.4} direction='down' padding fullWidth>
                    <div>
                        <p className='text-center text-white mt-10 text-3xl font-bold'>Layanan Inspektorat Daerah</p>
                        <div className='desktop:container desktop:w-96 mt-5'>
                            <p className='text-center text-white'>Inspektorat Daerah menyediakan beragam layanan yang bertujuan untuk memastikan transparansi, akuntabilitas, dan efektivitas pemerintahan daerah.</p>
                        </div>
                    </div>
                </FadeIn>
                <FadeInMenu delay={0.4} direction='right' padding fullWidth>
                    <div className="desktop:container mx-auto p-5">
                        <MenuBig />
                    </div>
                </FadeInMenu>
            </section>

            <FadeIn delay={0.4} direction='down' padding fullWidth>
                <section className='pt-10'>
                    <div className=' mb-10'>
                        <div className='h-600'>
                            <Articles />
                        </div>
                    </div>
                </section>
            </FadeIn>

            <section className="body-font mt-10 mb-10">
                <div className='flex flex-col w-full items-center justify-center desktop:p-0 phone:p-5'>
                    <h1 className='text-2xl mb-4'>TikTok</h1>
                    <blockquote className="tiktok-embed" cite={tiktok}
                                data-unique-id={tiktok.split("@")[1]} data-embed-type="creator"
                                style={{ minWidth: 325, width: '100%', margin:0, padding:0 }}>
                        <section>
                            <a target="_blank"
                               href={`${tiktok}?refer=creator_embed`}>@{tiktok.split("@")[1]}</a>
                        </section>
                    </blockquote>
                </div>
            </section>
        </div>
    )
}

export default HomeContent